import React from 'react';
import createForm from "./../../forms/Form";
import DateTimeInput from "../../../form/DateTimeInput";
import CheckBox from "../../../form/CheckBox";
import TextInput from "src/components/form/TextInput";

class BergmanInvoiceExportForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-3">
                        <DateTimeInput
                            name="startdate"
                            value={this.props.values.startdate}
                            label="Kezdés"
                            isClearable={true}
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("startdate")}
                        />
                    </div>
                    <div className="col-sm-3">
                        <DateTimeInput
                            name="enddate"
                            value={this.props.values.enddate}
                            label="Vég"
                            isClearable={true}
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("enddate")}
                        />
                    </div>
                    <div className="col-sm-3">
                        <TextInput
                            name="prefix"
                            value={this.props.values.prefix}
                            label="Előtag"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("prefix")}
                        />
                    </div>
                    <div className="col-sm-3">
                        <label className="control-label">&nbsp;</label>
                        <CheckBox
                            name="posfilter"
                            value={this.props.values.posfilter}
                            label="Pénztárgép nélküli számlák"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(BergmanInvoiceExportForm);
